module.exports = __webpack_public_path__ + "media/soft.be8910ba.mp3";